import React from "react";
import PropTypes from "prop-types";

const MessageContainer = ({ id, alignment, children, onMouseLeave }) => {
  const classNames = ["chat-content-container"];

  if (alignment) {
    classNames.push(`chat-content-container--${alignment}`);
  }

  return (
    <div
      id={id || null}
      className={classNames.join(" ")}
      onMouseLeave={onMouseLeave && onMouseLeave}
    >
      {children}
    </div>
  );
};

MessageContainer.propTypes = {};

export default MessageContainer;
